import { IconComponentProps } from '../IconTypes';

const CaretRight = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.4175 8.40988L14.0075 10.9999C14.3975 11.3899 14.3975 12.0199 14.0075 12.4099L11.4175 14.9999C10.7875 15.6299 9.70752 15.1799 9.70752 14.2899V9.10988C9.70752 8.21988 10.7875 7.77988 11.4175 8.40988Z"
      fill="currentColor"
    />
  </svg>
);

export default CaretRight;
